const isIPv4 = (value) => {
  const parts = value.split(".");
  return parts.length === 4 && parts.every((part) =>
    /^(0|[1-9][0-9]{0,2})$/.test(part) && Number(part) <= 255
  );
};

export const resolveNetworkSettings = (data) => {
  if (data.network_mode === "dhcp") {
    return {
      network_mode: "dhcp", static_ip: null, static_prefix: null,
      static_gateway: null, static_dns: "",
    };
  }
  if (data.network_mode !== "static") throw new Error("Select DHCP or Static IP.");
  const staticIP = (data.static_ip || "").trim();
  const gateway = (data.static_gateway || "").trim();
  if (!isIPv4(staticIP)) throw new Error("Enter a valid static IPv4 address.");
  if (!isIPv4(gateway)) throw new Error("Enter a valid IPv4 gateway.");
  const prefixText = String(data.static_prefix ?? "").trim();
  const prefix = Number(prefixText);
  if (!/^[0-9]+$/.test(prefixText) || !Number.isInteger(prefix) || prefix < 1 || prefix > 32) {
    throw new Error("Subnet prefix must be an integer between 1 and 32.");
  }
  const dnsText = (data.static_dns || "").trim();
  if (!dnsText) {
    throw new Error("Enter at least one DNS server for Static IP.");
  }

  const dns = dnsText.split(",").map((value) => value.trim());
  if (dns.some((value) => !value || !isIPv4(value))) {
    throw new Error("DNS servers must be comma-separated IPv4 addresses without empty entries.");
  }
  return {
    network_mode: "static", static_ip: staticIP, static_prefix: prefix,
    static_gateway: gateway, static_dns: dns.join(","),
  };
};
